import { render, staticRenderFns } from "./KPICardIndividual.vue?vue&type=template&id=24150c12&scoped=true"
import script from "./KPICardIndividual.vue?vue&type=script&lang=js"
export * from "./KPICardIndividual.vue?vue&type=script&lang=js"
import style0 from "./KPICardIndividual.vue?vue&type=style&index=0&id=24150c12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24150c12",
  null
  
)

export default component.exports